import styled, { css } from 'styled-components';
import {
  ContentInterface,
  SectionPropsInterface,
} from './ModalMonitoringTypes';

export const maxWidthPositionFixed = '600px';

export const visibilityAnimationRight = css`
  &.animated {
    right: 0;
    opacity: 1;
    transition: right 0.3s cubic-bezier(0.65, 0, 0.35, 1),
      opacity 0.3s cubic-bezier(0.65, 0, 0.35, 1);
  }
`;

export const WrapperContentModal = styled.div<ContentInterface>`
  width: 100%;
  max-width: ${maxWidthPositionFixed};
  background-color: #fff;
  position: fixed;
  top: 0;
  right: -100%;
  height: 100%;
  overflow-y: auto;
  opacity: 1;
  transition: right 0.3s cubic-bezier(0.65, 0, 0.35, 1),
    opacity 0.3s cubic-bezier(0.65, 0, 0.35, 1);

  ${({ theme }) => css`
    padding: ${theme.spacing.km6} ${theme.spacing.km8} 120px
      ${theme.spacing.km8};
  `}

  ${visibilityAnimationRight}
`;

export const ModalTitle = styled.div`
  fuel-typography p {
    display: inline !important;
  }
`;

export const Section = styled.section<SectionPropsInterface>`
  ${({ theme, hasDivider = false, gap = 'km8' }) => css`
    ${hasDivider
      ? css`
          padding-top: ${theme.spacing[gap]};
          margin-top: ${theme.spacing[gap]};
          border-top: ${theme.border.width.thinner} ${theme.border.style.solid}
            ${theme.color.border.neutral.default};
        `
      : css`
          margin-top: ${theme.spacing[gap]};
        `}
  `}
`;

export const WrapperSpacingBetween = styled.span`
  display: flex;
  justify-content: space-between;
  font-weight: inherit;
  font-size: inherit;

  * {
    font-weight: inherit;
    font-size: inherit;
  }
`;

export const HilightPayment = styled.span`
  color: ${({ theme }) => theme.color.text.neutral.strong};
  font-size: ${({ theme }) => theme.font.size.m4};
`;

export const WrapperDisclaimer = styled.div`
  ${({ theme }) => css`
    margin-top: ${theme.spacing.km4};
  `}
`;

export const WrapperLink = styled.div`
  ${({ theme }) => css`
    cursor: pointer;
    text-decoration: underline;
    font-weight: ${theme.font.weight.medium};
  `}
`;

export const ContentSkeleton = styled.div`
  ${({ theme }) => css`
  margin-top: gap: ${theme.spacing.km1};
  `}
`;
